import moment from 'moment'
import { transform, isEqual, isObject } from 'lodash'
import { ERRORS_MESSAGES } from '@/services/constants.service'

/**
 * Get value of an object property/path even if it's nested
 */
export function getValueByPath (obj, path) {
  const value = path.split('.').reduce((o, i) => o[i], obj)
  return value
}

export function toUTCDay (date) {
  if (date) {
    if (date instanceof moment) {
      date = date.isValid() && date.toDate()
    } else {
      date = new Date(date)
    }
  } else {
    return null
  }
  return date && moment()
    .utc()
    .year(date.getFullYear())
    .month(date.getMonth())
    .date(date.getDate())
    .hour(0)
    .minute(0)
    .seconds(0)
    .milliseconds(0)
}

/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
export function difference (object, base) {
  return transform(object, (result, value, key) => {
    if (!isEqual(value, base[key])) {
      result[key] = isObject(value) && isObject(base[key]) ? difference(value, base[key]) : value
    }
  })
}

export function validateDatesDiff (firstDate, secondDate, maxDiff = 1) {
  const date = moment(new Date(firstDate))
  const relatedDate = moment(new Date(secondDate))

  if (date.isValid() && relatedDate.isValid()) {
    const diffDates = date.diff(relatedDate, 'days')

    if (diffDates > maxDiff) {
      return false
    }
  }
  return true
}

export function validateCurrentYear (value) {
  const date = moment(value)
  if (date.isValid()) {
    const currentYear = moment().year()
    const yearValidate = date.year()

    return currentYear === yearValidate ? '' : ERRORS_MESSAGES.exam_current_year
  }

  return ''
}

export function getShiftNumbers () {
  const arr = []
  let i = 1
  do {
    arr.push(i++)
  } while (i < 9)
  return arr
}
export function downloadFileUrl (url, filename) {
  const element = document.createElement('a')
  element.setAttribute('href', url)
  element.setAttribute('download', filename)
  element.style.display = 'none'
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}
